namespace GeniuzPOS.Product {
    export interface CsMatTypeRow {
        Id?: number;
        MatTypeId?: string;
        MatTypeName?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        FullName?: string;
    }

    export namespace CsMatTypeRow {
        export const idProperty = 'MatTypeId';
        export const nameProperty = 'FullName';
        export const localTextPrefix = 'Product.CsMatType';
        export const lookupKey = 'Product.CsMatType';

        export function getLookup(): Q.Lookup<CsMatTypeRow> {
            return Q.getLookup<CsMatTypeRow>('Product.CsMatType');
        }
        export const deletePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:วัสดุ:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:วัสดุ:Modify';
        export const readPermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:วัสดุ:View';
        export const updatePermission = '1POSBASE:ข้อมูลหลัก:ข้อมูลอ้างอิงสินค้า:วัสดุ:Modify';

        export declare const enum Fields {
            Id = "Id",
            MatTypeId = "MatTypeId",
            MatTypeName = "MatTypeName",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            FullName = "FullName"
        }
    }
}
